import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Form, Row } from '@contently/toolkit';
import { Field, getIn } from 'formik';

const renderLabel = question => {
  return (
    <Form.Label required={question.required} htmlFor={question.label}>
      {question.label}
    </Form.Label>
  );
};

const AnswerField = ({ question, handleBlur, handleChange, index }) => {
  const validate = answer => {
    if (!answer.length && question.required) {
      return 'An answer is required for this question';
    }
    return null;
  };

  return (
    <Row key={question.label}>
      {renderLabel(question)}
      <Field validate={validate} name={`questions.${index}.value`}>
        {({ field, form: { errors, touched } }) => {
          const error = getIn(errors, field.name);
          const touch = getIn(touched, field.name);

          return (
            <Fragment>
              <Form.ErrorWrapper touched={touch} error={error}>
                <Form.Input
                  type="text"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={question.value}
                  id={`questions.${index}.value`}
                  placeholder="Your answer..."
                />
              </Form.ErrorWrapper>
            </Fragment>
          );
        }}
      </Field>
    </Row>
  );
};

AnswerField.defaultProps = {
  errors: []
};

AnswerField.propTypes = {
  question: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    required: PropTypes.bool
  }).isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
  index: PropTypes.number.isRequired
};

export default AnswerField;



// WEBPACK FOOTER //
// ./app/javascript/app/components/questions/AnswerField.jsx